import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-static-accordion-data',
  templateUrl: './static-accordion-data.component.html',
  styleUrls: ['./static-accordion-data.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  encapsulation: ViewEncapsulation.None
})
export class StaticAccordionDataComponent {
  @Input()
  sectionData: any;

  @Input()
  sectionTitle?: string;

  @Input()
  singleRow: any;
}
